import FormBlock from '../../components/form/FormBlock.tsx';
import FormButtons from 'components/form/FormButtons';
import { UpdateSecretRequest } from '../../api/model.ts';
import { getFormSchema, getUiSchema } from '../../api/secrets/formSchema.ts';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import Loader from '../../components/Loader.tsx';
import { toast } from 'react-toastify';
import useSecret from 'api/secrets/useSecret.ts';
import useProjects from 'api/projects/useProjects.ts';
import { FaListUl } from 'react-icons/fa6';
import useDialog from 'hooks/useDialog.tsx';
import SecretUsageDialog from 'components/dialog/SecretUsageDialog.tsx';
import { SettingsFormShell } from 'components/settingsHub/SettingsFormShell';
import { ActionIconButton } from 'components/button/ActionIconButton';

const FORM_ID = 'secret-edit-form';

type Props = {
  secretId: string;
  onCancel: () => void;
  onSubmit: (secretId: string) => void;
};

const SecretEdit = ({ secretId, onCancel, onSubmit }: Props) => {
  const { secret, update, isLoading } = useSecret({ secretId });
  const { projects, isLoading: areProjectsLoading } = useProjects();
  const [showUsageDialog, UsageDialog] = useDialog(SecretUsageDialog);

  const handleUpdateSecret = async (formData: UpdateSecretRequest) => {
    try {
      await update.mutateAsync(formData);
      onSubmit(secretId);
    } catch (e) {
      if (!(e instanceof Error)) {
        toast.error('Error when updating secret.');
      }
    }
  };

  if (isLoading || areProjectsLoading) {
    return <Loader />;
  }

  return (
    <>
      <SettingsFormShell
        title="Edit Secret"
        headerActions={
          <ActionIconButton size="small" color="info" title="View usage" onClick={() => showUsageDialog(true)}>
            <FaListUl size={16} />
          </ActionIconButton>
        }
        footer={
          <FormButtons
            formId={FORM_ID}
            onCancel={onCancel}
            cancelBtnTxt="back to list"
            cancelBtnIcon={<ChevronLeftIcon />}
            disabled={update.isPending}
          />
        }
      >
        <FormBlock
          initialValues={secret}
          onSubmit={(formData) => void handleUpdateSecret(formData)}
          onCancel={onCancel}
          schema={getFormSchema(projects, undefined)}
          uiSchema={getUiSchema(false, secret)}
          formId={FORM_ID}
          disabled={update.isPending}
          showButtons={false}
        />
      </SettingsFormShell>
      <UsageDialog secret={secret!} onClose={() => showUsageDialog(false)} />
    </>
  );
};

export default SecretEdit;
